import { Component } from '@angular/core';
import { soundpostProductGLAccountEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Product GL Accounts') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostproductglaccount-form',
    templateUrl: './soundpostproductglaccount.form.component.html'
})
export class soundpostProductGLAccountFormComponent extends BaseFormComponent {
    public record!: soundpostProductGLAccountEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'productGLAccountDimensions', sectionName: 'Product GL Account Dimensions', isExpanded: false }
        ]);
    }
}

